import { ComparePage } from "./ComparePage";
import { useLang } from "../lib/i18n";
import { compareTactiqCopy } from "../lib/translations/pages/compare-tactiq";

export function CompareTactiq() {
  const lang = useLang();
  return <ComparePage copy={compareTactiqCopy[lang]} path="/compare/tactiq-vs-minuta" />;
}
